module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blank"
  }, [_c('navbar', {
    attrs: {
      "templateName": "JAOA"
    }
  }, [_c('select-template', {
    attrs: {
      "slot": "select"
    },
    on: {
      "template-selected": _vm.handleTemplateSelect
    },
    slot: "select"
  }, [_c('option', {
    attrs: {
      "value": "jaoa-article",
      "selected": "selected"
    }
  }, [_vm._v("Article")]), _c('option', {
    attrs: {
      "value": "jaoa-banner"
    }
  }, [_vm._v("Banner")]), _c('option', {
    attrs: {
      "value": "jaoa-intro"
    }
  }, [_vm._v("Intro")])])], 1), _c('transition', {
    attrs: {
      "name": "fade",
      "appear": "appear",
      "mode": "out-in"
    }
  }, [_c(_vm.currentTemplate, {
    tag: "component",
    attrs: {
      "current-template": _vm.currentTemplate
    }
  })], 1), _c('div', {
    staticClass: "toast-container toast-top-right",
    attrs: {
      "id": "toastContainer"
    }
  }, [_c('div', {
    staticClass: "toast"
  }, [_c('button', {
    staticClass: "toast-close-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toastClose
    }
  }, [_vm._v("x")]), _c('div', {
    staticClass: "toast-title"
  }), _c('div', {
    staticClass: "toast-message"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fa6ec58"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Jaoa.vue
// module id = 226
// module chunks = 0